import consumer from "../../shared/utils/cable_consumer"

export function UnreadMessageBadge() {
  return {
    unreadCount: 0,
    isAuthenticated: false,
    unreadByBrand: [],
    unreadCountSubscription: null,
    
    async init() {
      this.isAuthenticated = await this.checkAuthentication();
      
      if (this.isAuthenticated) {
        await this.loadUnreadCount();
        this.startPolling();
        this.setupWebSocketListener();
      }
      
      // 監聽聊天室開啟事件，當用戶開啟聊天室時重新載入未讀數量
      window.addEventListener('chat-opened', () => {
        this.loadUnreadCount();
      });
      
      // 監聽訊息已讀事件
      window.addEventListener('messages-read', () => {
        this.loadUnreadCount();
      });

      // 監聽 WebSocket 未讀計數更新事件
      window.addEventListener('unread-count-realtime-update', (event) => {
        this.handleRealtimeUnreadUpdate(event.detail);
      });
    },

    async checkAuthentication() {
      try {
        const response = await fetch('/chat/auth_status', {
          method: 'GET',
          credentials: 'include',
          headers: {
            'X-CSRF-Token': this.getCSRFToken()
          }
        });

        if (response.ok) {
          const data = await response.json();
          return !!data.authenticated;
        }
        
        return false;
      } catch (error) {
        return false;
      }
    },

    async loadUnreadCount() {
      if (!this.isAuthenticated) {
        return;
      }

      try {
        const response = await fetch('/chat/unread_count', {
          method: 'GET',
          credentials: 'include',
          headers: {
            'X-CSRF-Token': this.getCSRFToken()
          }
        });

        if (response.ok) {
          const contentType = response.headers.get('content-type');
          if (contentType && contentType.includes('application/json')) {
            const data = await response.json();
            this.unreadCount = data.total_unread_count || 0;
            this.unreadByBrand = data.unread_by_brand || [];
            
            // 觸發自定義事件，讓聊天模態框知道未讀數量已更新
            window.dispatchEvent(new CustomEvent('unread-count-updated', {
              detail: {
                totalCount: this.unreadCount,
                unreadByBrand: this.unreadByBrand
              }
            }));
          } else {
            // 回應不是 JSON，可能是 HTML（未登入或錯誤頁面）
            console.warn('API 回應不是 JSON 格式，可能是未登入狀態');
            this.isAuthenticated = false;
          }
        } else {
          // HTTP 錯誤狀態
          console.warn('API 回應錯誤:', response.status);
          if (response.status === 401 || response.status === 403) {
            this.isAuthenticated = false;
          }
        }
      } catch (error) {
        // 處理 JSON 解析錯誤或網路錯誤
        if (error.message.includes('Unexpected token')) {
          console.warn('JSON 解析失敗，可能是未登入狀態');
          this.isAuthenticated = false;
        } else {
          console.error('載入未讀訊息數量時發生錯誤:', error);
        }
      }
    },

    startPolling() {
      // 每30秒檢查一次未讀訊息數量
      setInterval(() => {
        this.loadUnreadCount();
      }, 30000);
    },

    setupWebSocketListener() {
      // 設置全域事件監聽器，接收來自 WebSocket 的未讀計數更新
      window.unreadBadgeInstance = this;
      
      // 訂閱未讀計數 WebSocket 頻道
      this.unreadCountSubscription = consumer.subscriptions.create("UnreadCountChannel", {
        connected: () => {
          // WebSocket 連線已建立
        },
        
        disconnected: () => {
          // WebSocket 連線已斷開
        },
        
        received: (data) => {
          if (data.type === "global_unread_count_update") {
            this.handleRealtimeUnreadUpdate({
              totalCount: data.total_unread_count,
              unreadByBrand: data.unread_by_brand
            });
          }
        }
      });
    },

    handleRealtimeUnreadUpdate(data) {
      // 直接從 WebSocket 事件更新未讀計數
      if (data && data.totalCount !== undefined) {
        this.unreadCount = data.totalCount;
        this.unreadByBrand = data.unreadByBrand || [];
        
        // 觸發自定義事件，讓聊天模態框知道未讀數量已更新
        window.dispatchEvent(new CustomEvent('unread-count-updated', {
          detail: {
            totalCount: this.unreadCount,
            unreadByBrand: this.unreadByBrand
          }
        }));
      }
    },

    getCSRFToken() {
      const token = document.querySelector('meta[name="csrf-token"]');
      return token ? token.getAttribute('content') : '';
    }
  };
}